import { z } from 'zod';

export const Member = z.object({
  id: z.number(),
  account_id: z.uuidv4(),
  email: z.email(),
  created_at: z.iso.datetime(),
});

export type Member = z.infer<typeof Member>;
